import { heartTheme, ThemeManager } from '@kaizen/design-tokens';
export const themeManager = new ThemeManager(heartTheme);
